<template>
  <div class="user-management" dir="rtl">
    <div class="container">
      <div class="header">
        <h1 class="page-title">إدارة المستخدمين</h1>
        <button class="btn btn-add" @click="openModalForAdd">
          إضافة مستخدم جديد
        </button>
      </div>

      <div
        v-if="showUserModal"
        class="modal-overlay"
        @click.self="closeUserModal"
      >
        <div class="modal-content">
          <h2 class="modal-title">
            {{ isEditMode ? "تعديل المستخدم" : "إضافة مستخدم جديد" }}
          </h2>
            <form @submit.prevent="handleUserSubmit">
            <div class="form-group">
              <label for="email" class="form-label">البريد الإلكتروني</label>
              <input
                type="email"
                id="email"
                v-model="userForm.email"
                class="form-control"
                placeholder="أدخل البريد الإلكتروني"
                required
              />
            </div>

            <div class="form-group">
              <label for="phoneNumber" class="form-label">رقم الهاتف</label>
              <input
                type="text"
                id="phoneNumber"
                v-model="userForm.phoneNumber"
                class="form-control"
                placeholder="أدخل رقم الهاتف"
                required
              />
            </div>

            <div class="form-group">
              <label for="role" class="form-label">الدور</label>

              <select
                id="role"
                v-model.number="userForm.role"
                class="form-control"
                required
              >
                <option value="" disabled>-- اختر الدور --</option>
                <option
                  v-for="option in roleOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="password" class="form-label">كلمة المرور</label>
              <input
                type="password"
                id="password"
                v-model="userForm.password"
                class="form-control"
                placeholder="أدخل كلمة المرور"
                :required="!isEditMode"
              />
            </div>

            <div class="form-group">
              <label for="confirmPassword" class="form-label">
                تأكيد كلمة المرور
              </label>
              <input
                type="password"
                id="confirmPassword"
                v-model="userForm.confirmPassword"
                class="form-control"
                placeholder="أدخل تأكيد كلمة المرور"
                :required="!isEditMode"
              />
            </div>

            <div class="modal-actions">
              <button type="submit" class="btn btn-primary">
                {{ isEditMode ? "تعديل المستخدم" : "إضافة المستخدم" }}
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeUserModal"
              >
                إغلاق
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="table-container">
        <h2 class="table-title">قائمة المستخدمين</h2>
        <table class="users-table">
          <thead>
            <tr>
              <th>التسلسل</th>
              <th>البريد الإلكتروني</th>
              <th>رقم الهاتف</th>
              <th>الدور</th>
              <th>الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" :key="user.id">
              <td>{{ (pageNumber - 1) * pageSize + (index + 1) }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.phoneNumber }}</td>

              <td>{{ roleText(user.role) }}</td>
           
                <td class="actions-cell">
                  <button class="btn-action edit" @click="openUserModalForEdit(user)">
                    <span class="action-icon">✎</span>
                    تعديل
                  </button>
                  <button class="btn-action delete" @click="deleteUser(user.id)">
                    <span class="action-icon">×</span>
                    حذف
                  </button>
                </td>
                
          
          
            </tr>
          </tbody>
        </table>
      </div>

      <custom-pagination
        :currentPage="pageNumber"
        :totalPages="totalPages"
        @page-changed="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import apiClient from "@/api";
import CustomPagination from "@/components/CustomPagination.vue";
import Swal from "sweetalert2";

export default {
  name: "UserManagement",
  components: { CustomPagination },
  data() {
    return {
      users: [],
      showUserModal: false,
      isEditMode: false,

      pageNumber: 1,
      pageSize: 5,
      totalPages: 1,

      userForm: {
        id: null,
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
        role: "",
      },

      roleOptions: [
        { value: 1, text: "إدمن" },
        { value: 2, text: "مستخدم" },
      ],
    };
  },
  methods: {
    async getAllUsers() {
      try {
        const response = await apiClient.get("/api/Auth/GetAllUsersForApp", {
          params: { PageNumber: this.pageNumber, PageSize: this.pageSize },
        });

        this.users = response.data.items;
        this.pageNumber = response.data.pageNumber;
        this.totalPages = response.data.totalPages;
      } catch (error) {
        console.error("حدث خطأ أثناء جلب المستخدمين", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء جلب المستخدمين",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    handlePageChange(newPage) {
      this.pageNumber = newPage;
      this.getAllUsers();
    },

    async handleUserSubmit() {
      if (
        (!this.isEditMode ||
          this.userForm.password ||
          this.userForm.confirmPassword) &&
        this.userForm.password !== this.userForm.confirmPassword
      ) {
        Swal.fire({
          icon: "warning",
          title: "تنبيه",
          text: "كلمة المرور وتأكيدها غير متطابقتين",
          timer: 3000,
          showConfirmButton: false,
        });
        return;
      }

      const requestBody = {
        email: this.userForm.email,
        phoneNumber: this.userForm.phoneNumber,
        password: this.userForm.password,
        role: this.userForm.role,
      };

      if (this.isEditMode) {
        try {
          await apiClient.put(
            "/api/Auth/EditUserForApp/" + this.userForm.id,
            {
              email: this.userForm.email,
              phoneNumber: this.userForm.phoneNumber,
              password: this.userForm.password,
              role: this.userForm.role,
            },
          );
          Swal.fire({
            icon: "success",
            title: "تم",
            text: "تم تعديل المستخدم بنجاح",
            timer: 2000,
            showConfirmButton: false,
          });
          this.closeUserModal();
          this.getAllUsers();
        } catch (error) {
          console.error("حدث خطأ أثناء تعديل المستخدم", error);
          Swal.fire({
            icon: "error",
            title: "خطأ",
            text: "حدث خطأ أثناء تعديل المستخدم",
            timer: 3000,
            showConfirmButton: false,
          });
        }
      } else {
        try {
          await apiClient.post("/api/Auth/CreateUserForApp", requestBody);
          Swal.fire({
            icon: "success",
            title: "تم",
            text: "تم إنشاء المستخدم بنجاح",
            timer: 2000,
            showConfirmButton: false,
          });
          this.closeUserModal();
          this.getAllUsers();
        } catch (error) {
          console.error("حدث خطأ أثناء إنشاء المستخدم", error);
          Swal.fire({
            icon: "error",
            title: "خطأ",
            text: "حدث خطأ أثناء إنشاء المستخدم",
            timer: 3000,
            showConfirmButton: false,
          });
        }
      }
    },

    openModalForAdd() {
      this.isEditMode = false;
      this.resetUserForm();
      this.showUserModal = true;
    },

    openUserModalForEdit(user) {
      this.isEditMode = true;
      this.userForm = {
        id: user.id,
        email: user.email,
        phoneNumber: user.phoneNumber,
        password: "",
        confirmPassword: "",
        role: user.role,
      };
      this.showUserModal = true;
    },

    closeUserModal() {
      this.showUserModal = false;
      this.resetUserForm();
    },

    resetUserForm() {
      this.userForm = {
        id: null,
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
        role: "",
      };
    },

    async deleteUser(id) {
      const result = await Swal.fire({
        title: "تأكيد الحذف",
        text: "هل أنت متأكد من حذف هذا المستخدم؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "نعم، احذفه",
        cancelButtonText: "إلغاء",
      });

      if (result.isConfirmed) {
        try {
          await apiClient.delete("/api/Auth/DeleteUserForApp/" + id);
          Swal.fire({
            icon: "success",
            title: "تم الحذف",
            text: "تم حذف المستخدم بنجاح",
            timer: 2000,
            showConfirmButton: false,
          });
          this.getAllUsers();
        } catch (error) {
          console.error("حدث خطأ أثناء حذف المستخدم", error);
          Swal.fire({
            icon: "error",
            title: "خطأ",
            text: "حدث خطأ أثناء حذف المستخدم",
            timer: 3000,
            showConfirmButton: false,
          });
        }
      }
    },

    roleText(roleValue) {
      const selectedOption = this.roleOptions.find(
        (opt) => opt.value === roleValue
      );
      return selectedOption
        ? selectedOption.text
        : `دور غير معروف (${roleValue})`;
    },
  },

  mounted() {
    this.getAllUsers();
  },
};
</script>

<style scoped>.user-management {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Section */
.header {
  text-align: center;
  margin-bottom: 3rem;
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  animation: slideDown 0.5s ease-out;
}

.page-title {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-weight: 400;
}

.page-subtitle {
  color: #718096;
  margin-bottom: 1.5rem;
}

.btn-add {
  background: #4299e1;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-add:hover {
  background: #3182ce;
  transform: translateY(-1px);
}

/* Table Section */
.table-container {
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.table-title {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
}

.users-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.users-table th {
  background: #f7fafc;
  padding: 1rem;
  font-weight: 600;
  color: #4a5568;
  text-align: right;
  border-bottom: 2px solid #e2e8f0;
}

.users-table td {
  padding: 1rem;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s;
}

.users-table tr:hover td {
  background-color: #f7fafc;
}

/* Role Badge */
.role-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.role-admin {
  background: #c6f6d5;
  color: #276749;
}

.role-user {
  background: #e9d8fd;
  color: #553c9a;
}

/* Table Actions */
.action-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.btn-action {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.btn-edit {
  background: #faf089;
  color: #744210;
}

.btn-edit:hover {
  background: #f6e05e;
}

.btn-delete {
  background: #fed7d7;
  color: #c53030;
}

.btn-delete:hover {
  background: #feb2b2;
}

/* Modal Styles */
.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  border-radius: 1rem;
  width: 90%;
  max-width: 500px;
  position: relative;
  padding: 2rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: modalSlideIn 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.modal-title {
  font-size: 1.5rem;
  color: #2d3748;
  font-weight: 600;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #718096;
  cursor: pointer;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #2d3748;
}

/* Form Styles */
.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
  outline: none;
}

select.form-control {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234A5568'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: left 0.75rem center;
  background-size: 1rem;
  padding-left: 2.5rem;
}

.password-input {
  position: relative;
}

.password-toggle {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #718096;
  cursor: pointer;
  padding: 0.25rem;
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.btn-submit {
  background: #4299e1;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-submit:hover {
  background: #3182ce;
}

.btn-cancel {
  background: #e2e8f0;
  color: #4a5568;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #cbd5e0;
}

/* Animations */
@keyframes modalSlideIn {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .user-management {
    padding: 1rem;
  }

  .header {
    padding: 1.5rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .modal-content {
    padding: 1.5rem;
    margin: 1rem;
  }

  .modal-actions {
    flex-direction: column;
  }

  .btn-submit,
  .btn-cancel {
    width: 100%;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-action {
    width: 100%;
    justify-content: center;
  }
}

/* RTL Support */
[dir="rtl"] .modal-close {
  left: 1.5rem;
  right: auto;
}

[dir="rtl"] .form-control {
  text-align: right;
}

[dir="rtl"] .modal-actions {
  flex-direction: row-reverse;
}

[dir="rtl"] select.form-control {
  background-position: right 0.75rem center;
  padding-right: 2.5rem;
  padding-left: 0.75rem;
}
</style>
